

import { ApplicationUserModel, DepartmentModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import { departmentsStore } from '@/libs/departments/+state/store';

import DepartmentManagerList from '@/libs/settings/components/DepartmentManagerList.vue';

@Component({ components: { DepartmentManagerList } })
export default class DepartmentDialog extends Page {

    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    department : DepartmentModel | null = null;
    deleteDialog = false;
    deleting = false;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.department?.id == Guid.EmptyGuid();
    }
    
    open (id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close () {
        this.dialog = false;
    }

    private load (): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadDepartment().then((e) => {
                    this.loading = false;
                    resolve(e);
                }).catch((e: any) => {
                    reject(e);
                });
            });
        }
        else {
            this.department = {
                id: Guid.EmptyGuid(),
                name: ""
            } as DepartmentModel;
            return new Promise((resolve, reject) => {
                resolve(null);
            });
        }
    }

    private loadDepartment() {
        return new Promise((resolve, reject) => {
            departmentsStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(departmentsStore, CrudReponse.Get).then((e) => {
                this.department = e;
                resolve(e);
            }).catch((e: any) => {
                reject(e);
            });
        });
    }

    private save () {
        if (this.form.validate()) {
            const department = {...this.department} as DepartmentModel;
            // Odfiltruj nevyplněné manažery oddělení
            if (Array.isArray(department.departmentManagers)) {
                department.departmentManagers = department.departmentManagers.filter((m: any) => {
                    const id = m?.tenantUserId as string | undefined;
                    return !!id && id !== Guid.EmptyGuid();
                });
            }
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                departmentsStore.dispatch(CrudAction.Create, { item: department });
                this.subscribe(departmentsStore, CrudReponse.Create).then(() => {
                    this.load().then(() => {
                        this.saving = false;
                        this.close();
                    });
                }).catch((e) => {
                    this.saving = false;
                    throw e;
                });
            }
            else {
                departmentsStore.dispatch(CrudAction.Update, { item: department });
                this.subscribe(departmentsStore, CrudReponse.Update).then(() => {
                    this.load().then(() => {
                        this.saving = false;
                        this.close();
                    });
                }).catch((e) => {
                    this.saving = false;
                    throw e;
                });
            }
        }
    }

    deleteClick () {
        this.deleteDialog = true;
    }

    deleteDepartment () {
        this.deleting = true;
        departmentsStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(departmentsStore, CrudReponse.Delete).then((e: any) => {
            this.deleting = false;
            this.deleteDialog = false;
            this.close();
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

}
